import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { QrCode } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const FormationQR = ({ slug, title }) => {
  const [open, setOpen] = useState(false);
  const url = `${window.location.origin}/formations/${slug}?ref=qr`;
  return (
    <>
      <button
        type="button"
        data-testid={`formation-qr-btn-${slug}`}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        title="Afficher le QR code"
        className="inline-flex items-center justify-center gap-1.5 px-3 py-2.5 rounded-full text-xs font-semibold text-[#012141] border border-[#012141]/15 hover:bg-[#012141]/5 transition-all"
      >
        <QrCode size={14} /> QR
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`formation-qr-dialog-${slug}`} className="max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-heading text-[#012141] text-center">{title}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-slate-500 text-center -mt-1">Scannez pour ouvrir cette formation sur votre téléphone.</p>
          <div className="mx-auto my-3 p-4 bg-white rounded-2xl border border-[#012141]/10 shadow-sm">
            <QRCodeSVG value={url} size={204} level="M" fgColor="#012141" bgColor="#FFFFFF" />
          </div>
          <div className="text-xs text-slate-400 text-center break-all">{url}</div>
        </DialogContent>
      </Dialog>
    </>
  );
};
